module.exports = __webpack_public_path__ + "img/logo.fba6429c.png";